'use client';
import { memo } from 'react';
import { Controller } from 'react-hook-form';

import SelectField from 'shared/Inputs/SelectField';
import PhoneField from 'shared/Inputs/PhoneField';
import TextField from 'shared/Inputs/TextField';

const ControllerInput = ({ inputsDataArray, control, trigger = null }) => (
  <>
    {inputsDataArray?.map(({ name, placeholder, type, options, label = null, ...args }) => (
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field: { value, onChange, ref }, fieldState: { error } }) => {
          switch (type) {
            case 'select':
              return (
                <SelectField
                  name={name}
                  value={value}
                  options={options}
                  label={label ?? placeholder}
                  placeholder={placeholder}
                  error={Boolean(error?.message)}
                  hint={error?.message}
                  trigger={trigger}
                  onChange={onChange}
                  {...args}
                />
              );
            case 'phone':
              return (
                <PhoneField
                  inputRef={ref}
                  name={name}
                  value={value}
                  label={label ?? placeholder}
                  placeholder={placeholder}
                  error={Boolean(error?.message)}
                  hint={error?.message}
                  trigger={trigger}
                  flex="1"
                  onChange={onChange}
                  {...args}
                />
              );
            default:
              return (
                <TextField
                  inputRef={ref}
                  name={name}
                  type={type}
                  value={value}
                  label={label ?? placeholder}
                  placeholder={placeholder}
                  error={Boolean(error?.message)}
                  hint={error?.message}
                  trigger={trigger}
                  h="full"
                  flex="1"
                  onChange={onChange}
                  {...args}
                />
              );
          }
        }}
      />
    ))}
  </>
);

export default memo(ControllerInput);
